module.exports = __webpack_public_path__ + "static/media/title.5c2b21d5.png";